<template>
  <i-select :value="value" :clearable="true" v-on="$listeners">
    <i-option
      v-for="(label, key) in statuses"
      :key="key"
      :value="key"
      :label="label"
    />
  </i-select>
</template>

<script>
  export default {
    props: {
      value: {
        type: [String, Number],
        default: null
      }
    },

    computed: {
      statuses: function() {
        return this.$t('mailer.sender.state');
      }
    }
  };
</script>
